import { SchoolOutlined } from "@mui/icons-material";

const educationBackgroundResource = {
    title: "Educational Background",
    singular: "Education",

    collectionField: "educationBackgrounds",

    displayField: "schoolName",
    icon: SchoolOutlined,

    columns: [
        {
            field: "level",
            header: "Level",
            type: "text"
        },
        {
            field: "schoolName",
            header: "School Name",
            type: "text"
        },
        {
            field: "course",
            header: "Course",
            type: "text"
        },
        {
            field: "yearGraduated",
            header: "Year Graduated",
            type: "number"
        },
        {
            field: "honors",
            header: "Honors",
            type: "text"
        }
    ],

    fields: {
        level: {
            name: "level",
            label: "Level",
            type: "text",
            required: true,
            options: [
                { value: "Elementary", label: "Elementary" },
                { value: "High School", label: "High School" },
                { value: "College", label: "College" },
                { value: "Vocational", label: "Vocational" },
                { value: "Graduate", label: "Graduate" }
            ]
        },
        schoolName: {
            name: "schoolName",
            label: "School Name",
            type: "text",
            required: true
        },
        course: {
            name: "course",
            label: "Course",
            type: "text"
        },
        periodFrom: {
            name: "periodFrom",
            label: "Period From",
            type: "date"
        },
        periodTo: {
            name: "periodTo",
            label: "Period To",
            type: "date"
        },
        yearGraduated: {
            name: "yearGraduated",
            label: "Year Graduated",
            type: "number"
        },
        honors: {
            name: "honors",
            label: "Honors",
            type: "text",
            multiline: true
        }
    }
};

export default educationBackgroundResource;
